import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import {IntermediatePart} from "../../parts/intermediatePart";
import {ShowerBodyType} from "../../constants";
import {Shower} from "../../parts/shower";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import store from "../../../../../store";
import {toggleNotCompatibleView} from "../../../../../actions/selectionFunctions";

export default class ShowerFloor extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_floor';
    this.partName = 'Floor';
    this.translateId = "visualizer.bathroom.shower.shower_floor";
    this.homePageTitle = 'Shower Flooring';
    this.dbName = 'ShowerFloor';
    this.isStoneFeature = true;
    this.selectedByUser = false;
    this.shadowName = "Floor";
    this.layerPriority = 6;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new ShowerFloor())
  }

  applyFeatureIfNotCompatible() {
    const parent = this.getParent();
    const shower = parent.getParent();
    shower.showerFloorIsActive = true;
    if (shower.layout && shower.showerTubComboIsActive()) {
      const comboPart = shower.layout.parts[ShowerTubCombo.id];
      comboPart.showerTubComboIsActive = false;
    }
  }

  handleClick(ignoreLocked) {
    super.handleClick(ignoreLocked);
    if (this.notAvailableInVisualizer || getFeatureIsLocked(this)) {
      return
    }
    const parent = this.getParent();
    const shower = parent.getParent();
    if ((!shower.showerFloorIsActive || shower.showerTubComboIsActive()) && !window.location.hash.includes("visualizer")) {
      store.dispatch(toggleNotCompatibleView(true));
      return;
    }

    this.applyFeatureIfNotCompatible();

    this.getParent().selectedByUser = true;
    const threshold = shower.threshold;
    if (threshold && !threshold.selectedByUser) {
      const thresholdAvailableFeatures = threshold.navigationSubItems();
      const currentFloorName = this.getSplittedFeatureName();
      const sameThreshold = thresholdAvailableFeatures.find(tr => tr.part.getSplittedFeatureName() === currentFloorName);
      if (sameThreshold) {
        super.handleClick.call(sameThreshold.part);
        threshold.selectedByUser = false;
      }
    }
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  setLayers(layout) {

    if (this.getParent().showerTubComboIsActive()) {
      super.hideLayers();
      return;
    }

    if (this.getParent().customBodyType === ShowerBodyType.Door) {
      const showerDoorParent = this.getParent().showerDoor;
      if (showerDoorParent && showerDoorParent.activeFeature) {
        const currentShowerPanCondition = showerDoorParent.activeFeature.metaData["ShowerPan"];
        if (!currentShowerPanCondition || (currentShowerPanCondition && !currentShowerPanCondition.includes("Threshold"))) {
          super.hideLayers();
          return;
        }
      }
    }

    const conditions = this.getArrayOfConditions();
    if (!this.shadowFeature || (this.shadowFeature && !this.shadowFeature.matchesMetaForArrayOfConditions(conditions))) {
      this.setShadowFeature();
    }
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(conditions)
        || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }
    this.setDefault();
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    return [{
      propName: 'ShowerSize',
      propValue: this.getParent().showerSize()
    }];
  }

  setDefault() {
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    if (!super.tryToSetTheSameFeature(filteredFeatures)) {
      const hardCodedDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Sahara Autumn  Porcelain Tile");
      });
      const placeholderDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
      });
      this.activeFeature = hardCodedDefault || filteredFeatures[0];
      this.placeholderFeature = placeholderDefault || null;
      this.setShadowFeature();
    }
  }

  setZIndex(zIndexes) {
    if (this.getParent().activeSubType() === Shower.Type.Custom) {
      const zIndex = zIndexes.Shower.Custom60in.Floor;
      const zIndex2 = zIndexes.Shower.Custom60in.FloorShadow;
      if (zIndexes && this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (zIndexes && this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
      if(zIndexes && this.shadowFeature) {
        this.shadowFeature.layer.zIndex = zIndex2;
      }
    }
  }
}
